// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  background-color: var(--ion-color-primary);
  --ion-background-color: var(--ion-color-primary);
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  height: 100%;
  background-color: var(--ion-color-primary);
  --ion-background-color: var(--ion-color-primary);
  padding-top: var(--ion-safe-area-top, 0);
}
.login .form {
  width: 100%;
  max-width: 360px;
  padding-left: var(--spacing);
  padding-right: var(--spacing);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.login .form .logo {
  padding: 0 var(--spacing-double) var(--spacing-double) var(--spacing-double);
  margin: 0 auto;
}
.login .form ion-list {
  padding: 0;
}
.login .form ion-label {
  color: var(--ion-color-primary-contrast);
  display: block;
  margin-bottom: var(--spacing-half);
  margin-top: var(--spacing);
}
.login .form ion-label:first-of-type {
  margin-top: 0;
}
.login .form ion-input {
  color: var(--ion-color-primary-contrast);
  caret-color: var(--ion-color-primary-contrast);
  border: 1px solid var(--ion-color-primary-contrast);
  --padding-top: var(--spacing-half);
  --padding-bottom: var(--spacing-half);
  --padding-start: var(--spacing-half);
  --padding-end: var(--spacing-half);
  --highlight-color: var(--ion-color-primary-contrast);
}
.login .form ion-text {
  text-align: right;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-milli);
  display: block;
  margin-top: var(--spacing-quarter);
}
.login .form__actions {
  margin-top: var(--spacing);
}
.login .form__actions ion-button {
  margin-bottom: var(--spacing-half);
}
.login .form__actions ion-button.request-password {
  --box-shadow: none;
}
.login .version {
  font-size: var(--font-size-milli);
  color: var(--ion-color-primary-contrast);
}
.login .footer {
  width: 100%;
}
.login .footer__description {
  text-align: center;
}
.login .footer__contact {
  padding-bottom: var(--ion-safe-area-bottom, 0);
  text-align: center;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-milli);
}

.loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  font-weight: var(--font-weight-bold);
  color: var(--ion-color-primary-contrast);
}
.loading ion-spinner {
  color: var(--ion-color-primary-contrast);
  width: 20vw;
  height: 20vw;
  max-width: 100px;
  max-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.page.scss"],"names":[],"mappings":"AAAA;EACC,0CAAA;EACA,gDAAA;AACD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,gDAAA;EACA,wCAAA;AAAD;AAGC;EACC,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AADF;AAGE;EACC,4EAAA;EACA,cAAA;AADH;AAIE;EACC,UAAA;AAFH;AAKE;EACC,wCAAA;EACA,cAAA;EACA,kCAAA;EACA,0BAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAOE;EACC,wCAAA;EACA,8CAAA;EACA,mDAAA;EAEA,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,kCAAA;EAEA,oDAAA;AAPH;AAUE;EACC,iBAAA;EACA,oCAAA;EACA,iCAAA;EACA,cAAA;EACA,kCAAA;AARH;AAWE;EACC,0BAAA;AATH;AAWG;EACC,kCAAA;AATJ;AAWI;EACC,kBAAA;AATL;AAeC;EACC,iCAAA;EACA,wCAAA;AAbF;AAgBC;EACC,WAAA;AAdF;AAgBE;EACC,kBAAA;AAdH;AAiBE;EACC,8CAAA;EACA,kBAAA;EACA,oCAAA;EACA,iCAAA;AAfH;;AAqBA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAEA,oCAAA;EACA,wCAAA;AAnBD;AAqBC;EACC,wCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAnBF","sourcesContent":["ion-content {\n\tbackground-color: var(--ion-color-primary);\n\t--ion-background-color: var(--ion-color-primary);\n}\n\n\n.login {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: stretch;\n\talign-items: center;\n\theight: 100%;\n\tbackground-color: var(--ion-color-primary);\n\t--ion-background-color: var(--ion-color-primary);\n\tpadding-top: var(--ion-safe-area-top, 0);\n\n\n\t.form {\n\t\twidth: 100%;\n\t\tmax-width: 360px; // A nice default width on large screens\n\t\tpadding-left: var(--spacing);\n\t\tpadding-right: var(--spacing);\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\n\t\t.logo {\n\t\t\tpadding: 0 var(--spacing-double) var(--spacing-double) var(--spacing-double);\n\t\t\tmargin: 0 auto;\n\t\t}\n\n\t\tion-list {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\tion-label {\n\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: var(--spacing-half);\n\t\t\tmargin-top: var(--spacing);\n\n\t\t\t&:first-of-type {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\n\t\tion-input {\n\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\tcaret-color: var(--ion-color-primary-contrast);\n\t\t\tborder: 1px solid var(--ion-color-primary-contrast);\n\n\t\t\t--padding-top: var(--spacing-half);\n\t\t\t--padding-bottom: var(--spacing-half);\n\t\t\t--padding-start: var(--spacing-half);\n\t\t\t--padding-end: var(--spacing-half);\n\n\t\t\t--highlight-color: var(--ion-color-primary-contrast);\n\t\t}\n\n\t\tion-text {\n\t\t\ttext-align: right;\n\t\t\tfont-weight: var(--font-weight-bold);\n\t\t\tfont-size: var(--font-size-milli);\n\t\t\tdisplay: block;\n\t\t\tmargin-top: var(--spacing-quarter);\n\t\t}\n\n\t\t&__actions {\n\t\t\tmargin-top: var(--spacing);\n\n\t\t\tion-button {\n\t\t\t\tmargin-bottom: var(--spacing-half);\n\n\t\t\t\t&.request-password {\n\t\t\t\t\t--box-shadow: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.version {\n\t\tfont-size: var(--font-size-milli);\n\t\tcolor: var(--ion-color-primary-contrast);\n\t}\n\n\t.footer {\n\t\twidth: 100%;\n\t\n\t\t&__description {\n\t\t\ttext-align: center;\t\n\t\t}\n\t\n\t\t&__contact {\n\t\t\tpadding-bottom: var(--ion-safe-area-bottom, 0);\n\t\t\ttext-align: center;\n\t\t\tfont-weight: var(--font-weight-bold);\n\t\t\tfont-size: var(--font-size-milli);\n\t\t}\n\t}\n}\n\n\n.loading {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-grow: 1;\n\n\tfont-weight: var(--font-weight-bold);\n\tcolor: var(--ion-color-primary-contrast);\n\n\tion-spinner {\n\t\tcolor: var(--ion-color-primary-contrast);\n\t\twidth: 20vw;\n\t\theight: 20vw;\n\t\tmax-width: 100px;\n\t\tmax-height: 100px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
